import * as React from "react";
import { cn } from "./cn";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        "flex min-h-[96px] w-full rounded-card border border-border bg-white px-3 py-2 text-sm text-ink placeholder:text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50",
        // A field marked aria-invalid outlines itself in the error colour, so
        // every form gets the same look from the one flag it already sets.
        "aria-[invalid=true]:border-error aria-[invalid=true]:ring-1 aria-[invalid=true]:ring-error aria-[invalid=true]:bg-error/5",
        "aria-[invalid=true]:focus-visible:ring-2 aria-[invalid=true]:focus-visible:ring-error",
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";
